import { FC, useRef, CSSProperties, useMemo, useContext } from 'react';
// 方法
import useClickOutside from '../hooks/useClickOutside';
import LayoutContext from '../../PageLayout/context/LayoutContext';

export interface ContextMenuAlertProps {
  visible: boolean;
  path?: string;
  left?: number;
  top?: number;
  onCancel?: Function;
  onRefresh?: Function;
  onClose?: (path: any) => void;
}
type optionType =
  | 'refresh'
  | 'closeLeft'
  | 'closeRight'
  | 'close'
  | 'closeOther';
interface IOptionItem {
  value: optionType;
  text: string;
}
const optionItem: IOptionItem[] = [
  {
    value: 'refresh',
    text: '刷新当前页',
  },
  {
    value: 'closeLeft',
    text: '关闭左侧页',
  },
  {
    value: 'closeRight',
    text: '关闭右侧页',
  },
  {
    value: 'close',
    text: '关闭当前页',
  },
  {
    value: 'closeOther',
    text: '关闭其他页',
  },
];
/** 菜单操作 */
const ContextMenuAlert: FC<ContextMenuAlertProps> = props => {
  const { visible, path, left, top, onCancel, onRefresh, onClose } = props;
  const alertRef = useRef<HTMLDivElement>(null);
  const { dispatch, routeTabs } = useContext(LayoutContext);
  useClickOutside(alertRef, () => {
    onCancel && onCancel();
  });
  /** 点击操作按钮 */
  const handleClick = (val: optionType) => {
    const findItem = routeTabs?.find(v => v.path === path);
    switch (val) {
      case 'refresh':
        onRefresh && onRefresh();
        break;
      case 'closeLeft':
        dispatch('deleteRouteTab', { type: 'left', key: path });
        break;
      case 'closeRight':
        dispatch('deleteRouteTab', { type: 'right', key: path });
        break;
      case 'close':
        onClose && onClose(path);
        break;
      case 'closeOther':
        dispatch('closeOtherRouteTab', findItem);
        break;
      default:
        break;
    }
    onCancel && onCancel();
  };
  /** 样式 */
  const styleObj: CSSProperties = useMemo(() => {
    return {
      display: visible ? 'block' : 'none',
      left: left && `${left}px`,
      top: top && `${top}px`,
    };
  }, [visible, left, top]);
  /** 操作按钮选项 */
  const currentOptionItem = useMemo(() => {
    if (path === '/') {
      return optionItem.filter(v => v.value !== 'close');
    }
    return optionItem;
  }, [path]);
  return (
    <div className="tl-page-head-alert" style={styleObj} ref={alertRef}>
      <ul className="tl-page-head-alert-content">
        {currentOptionItem &&
          currentOptionItem.map(item => {
            return (
              <li key={item.value} onClick={() => handleClick(item.value)}>
                {item.text}
              </li>
            );
          })}
      </ul>
    </div>
  );
};

export default ContextMenuAlert;
